<template>
  <v-list-item
    @click.stop="handleClick"
  >
    <v-list-item-content>
      <v-list-item-title>
        <v-icon
          small
          left
        >
          {{ action.icon }}
        </v-icon> {{ action.label }}
        <v-dialog
          v-if="!action.CreateInFullscreen"
          transition="dialog-bottom-transition"
          scrollable
          :value="dialog"
          persistent
          width="40%"
          @close="handleClose"
        >
          <v-card>
            <v-toolbar
              flat
              tile
            >
              <v-toolbar-title>
                <span class="text-capitalize">Create {{ action.type }}</span>
              </v-toolbar-title>
              <v-spacer />
              <v-toolbar-items>
                <template>
                  <v-btn
                    icon
                    @click="handleClose"
                  >
                    <v-icon>
                      mdi-close
                    </v-icon>
                  </v-btn>
                </template>
              </v-toolbar-items>
            </v-toolbar>

            <v-card-text style="height: 100%;">
              <component
                :is="action.type+'-create-update'"
                :project="project"
                no_activator
                @create="handleCreate"
                @close="handleClose"
                @click:outside="handleClose"
                @updateCloseConstraint="handleCloseConstraint"
              />
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>
<script>
  import DashboardCreateUpdate from './../Dashboard/Views/Projects/Dashboards/DashboardCreateUpdate'
  import QueryCreateUpdate from './../Dashboard/Views/Projects/Dashboards/QueryBuilder'
  import DatasetCreateUpdate from './../Dashboard/Views/Datastore/DatasetCreateUpdate.temp'
  import FunctionCreateUpdate from './../Dashboard/Views/Functions/FunctionCreateUpdate'
  import ApiCreateUpdate from './../Dashboard/Views/Apis/ApiCreateUpdate'
  import ConnectorCreateUpdate from './../Dashboard/Views/Integrations/IntegrationConfigCreate'
  export default {
    components: {
      'dashboard-create-update': DashboardCreateUpdate,
      'query-create-update': QueryCreateUpdate,
      'dataset-create-update': DatasetCreateUpdate,
      'function-create-update': FunctionCreateUpdate,
      'integration-create-update': ConnectorCreateUpdate,
      'api-create-update': ApiCreateUpdate,
    },
    props: {
      project: {
        type: Object,
        required: false,
        default: () => { return null },
      },
      action: {
        type: Object,
        default: () => { return { icon: 'test', label: 'test' } },
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        showComponent: false,
        closeConstraint: null,
      }
    },
    methods: {
      handleCloseConstraint (e) {
        this.closeConstraint = e
      },
      handleCreate (e) {
        this.$emit('create', e)
        this.handleClose()
      },
      handleClose () {
        const self = this

        if (this.closeConstraint == null) {
          self.dialog = false
          _.delay(() => {
            self.showComponent = false
            self.$emit('close')
          }, 300)
        } else {
          this.$store.commit('confirm', {
            message: self.closeConstraint,
            title: 'Warning',
            color: 'grey',
            onCancel: () => {},
            onConfirm: () => {
              self.dialog = false
              _.delay(() => {
                self.showComponent = false
                self.$emit('close')
              }, 300)
            },
          })
        }
      },
      handleClick (e) {
        if (this.action.CreateInFullscreen) {
          this.$router.push(`/projects/${this.project.id}/create/${this.action.type}`)
        } else {
          this.dialog = true
          this.$emit('click')
        }
      },
    },
  }
</script>
